import { memo } from 'react';
import { useLocation } from 'react-use';
import {
    Card,
    Image,
    Section,
    Tabs,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import { SelectSeason } from './select';
import styles from './style.module.scss';

export function TournamentHeader(props: any) {
    const location = useLocation();
    const {
        country = {},
        name,
        logo = '',
        tab = {},
        seasonName,
        seasonId,
        seasons,
        path,
        activeTab,
    } = props;
    return (
        <Section className={styles['tournament-header']}>
            <Card>
                {logo && (
                    <Card.Image>
                        <Image src={logo} alt={name} />
                    </Card.Image>
                )}
                <Card.Content>
                    <Title renderAs="h2">{name}</Title>
                    {country?.name && (
                        <Title renderAs="div" subtitle>
                            <Image src={country?.logo} alt={country.name} />
                            {country.name}
                        </Title>
                    )}
                </Card.Content>
                <SelectSeason
                    seasons={seasons}
                    url={location.pathname || ''}
                    seasonId={seasonId}
                    seasonName={seasonName}
                />
            </Card>
            <Tabs
                tabs={tab.items}
                pathUrl={path}
                activeTab={activeTab}
            ></Tabs>
        </Section>
    );
}

export default memo(TournamentHeader);
